import axiosInstance from './config/api';

export type LivekitRoomDetails = {
    Room: string;
    Token: string;
    URL: string;
    CallID: string;
};

export const getLivekitRoomDetails = (callID: string) => {
    return axiosInstance.get<LivekitRoomDetails>(`/workflows/livekit-creds/${callID}`).then((res) => res.data);
};
